// import React from 'react'
// import { UserSettings } from '@leverege/ui-redux'
// import HistoryScreen from './HistoryScreen'
import { HistoryScreenSettingsAction, DateRangeAction, QueryModeToggleAction, DensityToggleAction, EditHistorySettingsAction } from "./actions/index.js";
import HistoryListDataViewer from "./HistoryListDataViewer.js";
import HistoryTableDataViewer from "./HistoryTableDataViewer.js";
import HistoryDataViewer from "./HistoryDataViewer.js";
import HistoryListSupportDataViewer from "./HistoryListSupportDataViewer.js";
import HistoryTableSupportDataViewer from "./HistoryTableSupportDataViewer.js";
import HistoryViewModel from "./models/HistoryViewModel.js";
import HistoryViewEditor from "./editors/HistoryViewEditor.js";
import HistoryXYChartDataViewer from "./HistoryXYChartDataViewer.js";
import HistoryXYChartSupportDataViewer from "./HistoryXYChartSupportDataViewer.js";
import HistoryPieChartDataViewer from "./HistoryPieChartDataViewer.js";
import HistoryPieChartSupportDataViewer from "./HistoryPieChartSupportDataViewer.js";
import ThresholdizerSetup from "./thresholdizer/PluginSetup.js";
const install = molten => {
  ThresholdizerSetup.install(molten);
  molten.addPlugin('Model', {
    type: HistoryViewModel.TYPE,
    model: HistoryViewModel
  });
  molten.addPlugin('ModelEditor', {
    type: HistoryViewModel.TYPE,
    editor: HistoryViewEditor
  });
  molten.addPlugin('Action', HistoryScreenSettingsAction);
  molten.addPlugin('Action', DateRangeAction);
  molten.addPlugin('Action', QueryModeToggleAction);
  molten.addPlugin('Action', DensityToggleAction);
  molten.addPlugin('Action', EditHistorySettingsAction);
  molten.addPlugin('DataViewer', HistoryDataViewer);
  molten.addPlugin('DataViewer', HistoryListDataViewer);
  molten.addPlugin('DataViewer', HistoryTableDataViewer);
  molten.addPlugin('DataViewer', HistoryXYChartDataViewer);
  molten.addPlugin('DataViewer', HistoryPieChartDataViewer);
  molten.addPlugin('DataViewer', HistoryListSupportDataViewer);
  molten.addPlugin('DataViewer', HistoryTableSupportDataViewer);
  molten.addPlugin('DataViewer', HistoryXYChartSupportDataViewer);
  molten.addPlugin('DataViewer', HistoryPieChartSupportDataViewer);
};
export default {
  install
};